<template>
  <div>
    <FlightDetailsCollapsed
      class="mx-4"
      source-page="payment"
      :flights="flights"
      :dict="dict"
      :count-passengers="countPassengers"
      :is-youth="isYouth"
      :search-query="searchQuery"
      @onCardClick="bottomSheet.show(detailsBsName)"
    />
    <FlightDetailsBottomSheet
      source-page="payment"
      :flights-list="flights"
      :dict="dict"
      :name="detailsBsName"
    >
      <template #top-content>
        <PassengersList class="mb-4" :passengers="passengers" />
      </template>
    </FlightDetailsBottomSheet>
  </div>
</template>

<script setup lang="ts">
  import { controllerModel, type ticketDetails } from 'shared';
  import { FlightDetailsBottomSheet } from 'freedom-shared';
  import type { Airflow, Dict } from '@aviata/platform-types';

  import { FlightDetailsCollapsed } from '@/features/flight-details';

  import PassengersList from './PassengersList.vue';

  defineProps<{
    passengers: Airflow.Booking.Passenger[];
    flights: ticketDetails.types.MappedFlight[];
    dict: Dict.Entity;
    isYouth: boolean;
    countPassengers: number;
    searchQuery?: string | null;
  }>();

  const detailsBsName = 'payment-flight-details-bs';
  const bottomSheet = controllerModel.useBottomSheet();
</script>
